<template>
  <div class="content">
    <div class="search-area" v-if="dataList != null && dataList.length > 0"> 
    <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">计算的参数值</h3>
    <div v-for="da in dataList" class="t-left">{{da}}</div>
    </div>
    <div class="search-area mt15 t-left"  v-if="repositoryDescription != null && repositoryDescription != ''"> 
    <!-- {{dataList}} -->
         <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">算法名词解释</h3>
         {{repositoryDescription}}
         <!-- <div v-for="da in dataList" class="t-left" style="margin-top: 5px;">{{da}}</div> -->
    </div>
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <!-- <div class="button-area">
      <el-button icon="el-icon-s-data" size="medium" type="info" @click="classify">按省汇总</el-button>
    </div> -->
    <div class="back-color-fff p16 mt15">  
    <h3 class="t-left" style="margin: 0;margin-bottom: 10px;">计算结果</h3>
    <h3 class="mt0">近12个月频率(频繁度)</h3>
      <!-- <div class="echarts w70f fl" id="pie" :style="height"></div>  -->
      <div class="text-su-sty">
      <h3>离散系数(稳定度)</h3>
      </div>
      <div class="commodity">
          <ul class="ul-sty font-weight" >
            <!-- <dt>列表标题</dt> -->
            <li class="border-top-f1f1f1">离散度</li>
            <li class="border-top-f1f1f1">1</li>
            <li class="border-top-f1f1f1">2</li>  
            <li class="border-top-f1f1f1">3</li>
            <li class="border-top-f1f1f1">4</li> 
            <li class="border-top-f1f1f1">5</li>
            <li class="border-top-f1f1f1">6</li>
            <li class="border-top-f1f1f1">7</li>
            <li class="border-top-f1f1f1">8</li>
            <li class="border-top-f1f1f1">9</li>
            <li class="border-top-f1f1f1">10</li>
            <li class="border-top-f1f1f1">11</li>
            <li class="border-top-f1f1f1">12</li>
          </ul>
          <ul class="ul-sty" v-for="(va,index) in getVariationGridList">
            <!-- <dt>列表标题</dt> -->
            <li class="font-weight">{{va.variation}}</li>
            <li v-if="index == 5" style="background-color: #ff0000">{{va.m1}}</li>
            <li v-else>{{va.m1}}</li>
            <li v-if="index == 5" style="background-color: #ff0000">{{va.m2}}</li>  
            <li v-else>{{va.m2}}</li>  
            <li v-if="index == 5" style="background-color: #ff0000">{{va.m3}}</li>
            <li v-else>{{va.m3}}</li>
            <li v-if="index != 0 && index != 1 && index != 2 && index != 3" style="background-color: #ff0000">{{va.m4}}</li> 
            <li v-else>{{va.m4}}</li> 
            <li v-if="index != 0 && index != 1 && index != 2 && index != 3" style="background-color: #ff0000">{{va.m5}}</li>
            <li v-else>{{va.m5}}</li>
            <li v-if="index != 0 && index != 1 && index != 2" style="background-color: #ff0000">{{va.m6}}</li>
            <li v-else>{{va.m6}}</li>
            <li v-if="index != 0 && index != 1 && index != 2" style="background-color: #ff0000">{{va.m7}}</li>
            <li v-else>{{va.m7}}</li>
            <li v-if="index != 0 && index != 1 && index != 2" style="background-color: #ff0000">{{va.m8}}</li>
            <li v-else>{{va.m8}}</li>
            <li v-if="index !=0" style="background-color: #ffbd00">{{va.m9}}</li>
            <li v-else>{{va.m9}}</li>
            <li v-if="index !=0" style="background-color: #ffbd00">{{va.m10}}</li>
            <li v-else>{{va.m10}}</li>
            <li v-if="index ==0" style="background-color: #58af4e">{{va.m11}}</li>
            <li v-else style="background-color: #ffbd00">{{va.m11}}</li>
            <li v-if="index ==0" style="background-color: #58af4e">{{va.m12}}</li>
            <li v-else style="background-color: #ffbd00">{{va.m12}}</li>
          </ul>
      </div> 
      <div class="beizhu">备注：绿色为短尾、橘色为中尾、红色为长尾</div>

      <el-table
        :data="tableData"
        border
        style="width: 100%;">
        <el-table-column
          prop="goodsName"
          label="物料名称"
          align="left" header-align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="sales"
          label="销售量"
          align="right" header-align="center">
          <template slot-scope="scope">{{ scope.row.sales | numDigit}}</template>
        </el-table-column>
        <el-table-column
          prop="salesRatio"
          label="销售额占比(%)"
          align="right" header-align="center">
          <template slot-scope="scope">{{ scope.row.salesRatio * 100 | numDigit}}</template>
        </el-table-column>
        <el-table-column
          prop="cumulativeSalesRatio"
          label="累计销售额占比(%)"
          align="right" header-align="center">
          <template slot-scope="scope">{{ scope.row.cumulativeSalesRatio * 100 | numDigit}}</template>
        </el-table-column>
        <el-table-column
          prop="coefficientVariation"
          label="离散系数"
          align="right" header-align="center">
          <template slot-scope="scope">{{ scope.row.coefficientVariation | numDigit}}</template>
        </el-table-column>
        <el-table-column
          prop="requireFrequency"
          label="需求频率"
          align="right" header-align="center"> 
        </el-table-column>
        <el-table-column
          prop="modelType "
          label="商品分类"
          align="center">
          <template slot-scope="scope">{{ scope.row.modelType | modelType}}</template>
        </el-table-column>
      </el-table>
      <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      options: areaJson,
      year:'',
      page1: {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        mathConditionGuid:'',
        year: '', 
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        mathConditionGuid:'',
        year: '', 
      },
      winHeight: window.innerHeight,
      height: {
        height: '',
      },
      dialogTableVisible: false,
      tableData: [],
      classifyList: [],
      timeList: '',
      timeListS: '',
      customerCount: 0,
      franchiseeCount: 0,
      sumAmount: 0,
      totalGoodsSpecNum: 0,
      loading:false,
      getVariationGridList:[],
      dataList:[],
      repositoryDescription:'',
    };
  },
  created() {
    // 列表
    let self = this;
    let list = '';
    let canList = [];
     if(self.$router.history.current.query.list != null){
          list = JSON.parse(self.$router.history.current.query.list);   
          for(let i in list){ 
            let z = i +'：'+ list[i]
            canList.push(z); 
          }
    }
    if(self.$router.history.current.query.repositoryDescription != null){
          self.repositoryDescription = JSON.parse(self.$router.history.current.query.repositoryDescription);    
    } 
    console.log(canList);
    self.dataList = canList;
    self.page.mathConditionGuid = self.$router.history.current.query.guid;
    self.page1.mathConditionGuid = self.$router.history.current.query.guid;
    // self.year = self.$router.history.current.query.year;
    self.getData(false); 
    // setTimeout(function() {
    //   self.myChartsss();
    // }, 1000); 
  },
    mounted(){     
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-250+'px';
  }, 
  methods: {
    empty() {
      let self = this; 
      self.page1 = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
      };
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
      };
      self.getData();
    },
    getData() {
      let self = this;
      self.loading = true;  
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/select-goods-result/data/get-variation-grid`, self.page1).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.getVariationGridList = res.data.data;
          self.getDataTotal(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    getDataTotal(flg) {
      let self = this; 
      if (flg) {
        self.page.pageIndex = 1;
      } 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/select-goods-result/data/get-select_goods_result`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
    }); 
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getDataTotal();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getDataTotal();
    },
  },
};
</script>
</script>
<style scoped>
.el-range-editor.el-input__inner {
  padding: 0px;
}
.w70f {
  width: 70%;
}
.text-su-sty {
  width: 12%;
  height: 240px;
  float: left;
}
.text-su-sty h3 {
  width: 72px;
  height: 240px;
  margin:100px auto;  
  /*writing-mode: vertical-lr;*/
  /*writing-mode: tb-lr;*/
}
.beizhu {
  /*width: 100%;*/
  height: 50px;
  line-height: 50px;
  display: flex;
  padding-left: 12%; 
}
.commodity {
  width: 65.7vw;
  float: left;
  border-left: 1px solid #f1f1f1;
}
.commodity .ul-sty { 
   margin: 0;
   padding:0;
   height: 40px; 
}
.commodity .ul-sty li {
  float: left;
  width: 4.9vw;
  line-height: 40px;
  border-bottom: 1px solid #f1f1f1; 
  border-right: 1px solid #f1f1f1;
  text-align: center;
  list-style-type:none;
}
.border-top-f1f1f1 {
  border-top: 1px solid #f1f1f1;
}
</style>